import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { flexi_refills } from "../../../networking/urlEndPoints";

import Axios from "../../../networking/interceptor";

export const fetchFlexiDeliver = createAsyncThunk('fetchFlexiDeliver', async (requesteData, { rejectWithValue }) => {

    const { page,
        pharmacy_id,
        setLoading,
        setLoadMore,
        dispatch,
        patient_id,
    } = requesteData;

    try {
        const params = {
            page,
            pharmacy_id,
        }
        const response = await Axios.get(flexi_refills, { params })
        const data = response.data
        if (typeof setLoading === 'function') {
            setLoading(false)
        }

        if (patient_id) {
            dispatch(removeFlexiDeliverById(patient_id));
        }

        if (typeof setLoadMore === 'function') {
            setLoadMore(false)
        }

        return data;

    } catch (error) {
        if (typeof setLoading === 'function') {
            setLoading(false)
        }
        return rejectWithValue(error.response)
    }
});

const initialState = {
    loading: false,
    data: [],
    error: null,
    currentPage: 1,
    totalPages: null
}

const flexiDeliverSlice = createSlice({
    name: 'flexiDeliver',
    initialState,

    reducers: {
        removeFlexiDeliverById(state, action) {
            const flexiDeliverIdToRemove = action.payload;
            state.data = state.data.filter(item => item.id !== flexiDeliverIdToRemove);
        },
        clearData(state) {
            state.data = []
        },
        flexiDeliverRemovingPageNumber(state) {
            state.currentPage = 1
        }
    },

    extraReducers: (builder) => {
        builder.addCase(fetchFlexiDeliver.pending, (state) => {
            return {
                ...state,
                loading: true,
                error: null,
                // data: []
            }
        })
        builder.addCase(fetchFlexiDeliver.fulfilled, (state, action) => {
            const existingIds = new Set(state?.data?.map(item => item.id));
            const newData = action?.payload?.data?.filter(item => !existingIds.has(item.id));

            return {
                ...state,
                loading: false,
                data: [...state.data, ...newData],
                currentPage: action.payload.meta.current_page,
                totalPages: action.payload.meta.last_page,
                error: null
            };
        });

        builder.addCase(fetchFlexiDeliver.rejected, (state, action) => {
            return {
                ...state,
                loading: false,
                error: action.payload,
                data: []
            }
        })
        builder.addCase(flexiDeliverSlice.actions.removeFlexiDeliverById, (state, action) => {
            const flexiDeliverIdToRemove = action.payload;
            state.data = state.data.filter(item => item.flexi_deliver_id !== flexiDeliverIdToRemove);
        });
    }

})

export const { removeFlexiDeliverById, clearData, flexiDeliverRemovingPageNumber } = flexiDeliverSlice.actions;

export default flexiDeliverSlice.reducer; 